import { useScript } from '#nuxt-scripts/composables/useScript'
import { defineNuxtPlugin } from 'nuxt/app'
import { useScriptGoogleTagManager } from '/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/@nuxt+scripts@0.13.2_@azure+identity@4.13.0_@unhead+vue@2.1.12_vue@3.5.30_typescript@5._fcffdc5f42aedfa730096d76ca5daaca/node_modules/@nuxt/scripts/dist/runtime/registry/google-tag-manager.js'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-M4MBNGHD"})
    const hubspot = useScript({"key":"hubspot","id":"hs-script-loader","src":"https://js-eu1.hs-scripts.com/25800507.js","crossorigin":"anonymous","async":true,"defer":true,"tagPosition":"bodyClose"}, { use: () => ({ hubspot: window.hubspot }) })
    return { provide: { $scripts: { hubspot, googleTagManager } } }
  }
})